module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/evaluate/assets/bright-star.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/evaluate/assets/bright-star.png
// module id = 1318
// module chunks = 418